<template>
  <div>
    <component
      :is="bcsComponent"
      :popupParam.sync="popupParam"
      :survey.sync="survey"
      :evalItems.sync="evalItems"
      :evalItemClasses.sync="evalItemClasses"
      :contentHeight="contentHeight"
      :isOld.sync="isOld"
      @getDetail="getDetail"
      @closePopup="closePopup"
    />
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'brainCardiovascularDetail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        heaBrainCardiovascularSurveyId: '',
        /**
         * 상황 : 사후관리(탭) > 뇌심혈관계 평가 이력 링크 타고 들어온 경우
         * 목적 : tab의 위치를 위험평가로 고정
         */
        isEvalHistory: false, 
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      bcsComponent: () => import(`${'./brainCardiovascularInfo.vue'}`),
      survey: {
        heaBrainCardiovascularSurveyId: '',  // 뇌심혈관계 종합조사표 일련번호
        heaBrainCardiovascularStepCd: '',  // 진행상태
        userId: '',  // 근로자ID
        userName: '',  // 근로자명
        deptCd: '',  // 부서코드
        deptName: '',  // 부서명
        age: 0,  // 나이
        sexCd: '',  // 성별
        sexName: '',  // 성별
        birthDate: '', // 생년월일
        surveyDate: '',  // 평가일
        waistCircumference: '',  // 위험도_허리둘레
        bmi: '',  // 위험도_체질량 지수
        bloodPressure: '',  // 위험도_혈압
        hypertensionMedication: '',  // 위험도_고혈압 약 복용
        fastingBloodSugar: '',  // 위험도_공복 혈당
        diabetesMedication: '',  // 위험도_당뇨병 약 복용
        totalCholesterol: '',  // 위험도_총콜레스테롤
        egfr: '',  // 위험도_eGFR
        dipstickProteinuria: '',  // 위험도_Dipstick proteinuria 단백뇨
        smoking: '',  // 위험도_흡연상태
        physicallyActiveStatus: '',  // 위험도_신체 활동 여부
        regUserId: '',  //
        chgUserId: '',  //
        results: [], // 유해요인 평가결과 목록
        riskAssessment: {
          heaBrainCardiovascularRiskAssessmentId: '',  // 뇌심혈관계 위험평가 일련번호
          heaBrainCardiovascularSurveyId: '',  // 뇌심혈관계 일련번호
          adjustedCompositeRelativeRisk: '',  // 조정 복합 상대위험도
          riskDevelopDisease: '',  // 발병위험도(10년)
          avgRiskDevelopDisease: '',  // 평균발병위험도(10년)
          riskOrthodonticDevelopment: '',  // 교정발병위험도(10년)
          reducedRiskDevelopDisease: '',  // 발병위험도 감소치
          cardiovascularAge: '',  // 심뇌혈관 나이
          correctedCardiovascularAge: '',  // 교정 심뇌혈관 나이
          integratedRiskClassificationCriteria: '',  // 통합형 위험도 분류기준
          /** 기타 정보 */
          complexRelativeRisk: '',  // 개인별 복합 상대위험도
          correctionCompositeRelativeRisk: '',  // 개인별 교정 복합 상대위험도
          regUserId: '',  //
          chgUserId: '',  //
        }, // 위험평가
        suitEval: {
          heaBrainCardiovascularWorkSuitEvalId: '',  // 뇌심혈관계 업무적합성 일련번호
          heaBrainCardiovascularSurveyId: '',  // 뇌심혈관계 일련번호
          userId: '',  // 근로자ID (종합조사표 값)
          userName: '',  // 근로자명 (종합조사표 값)
          deptCd: '',  // 부서코드 (종합조사표 값)
          deptName: '',  // 부서명 (종합조사표 값)
          tasksPerformed: '',  // 수행업무
          diseaseReview: '',  // 임상증상 / 동반질환 검토의견
          habitsReview: '',  // 생활습관 / 검사항목 검토의견
          businessFactorsReview: '',  // 업무적요인 검토의견
          generalOpinionCd: '',  // 종합의견 - 결과
          generalOpinion: '',  // 종합의견 - 적합 이외인 경우 기술
          heaManagerId: '',  // 보건담당자 OR 의사
          regUserId: '',  //
          chgUserId: '',  //
        }, // 업무적합성 평가서
      },
      evalItems: [],
      evalItemClasses: [],
      editable: true,
      detailUrl: '',
      evalItemListUrl: '',
    };
  },
  computed: {
    isOld() {
      return Boolean(this.popupParam.heaBrainCardiovascularSurveyId)
    },
    checkboxItems() {
      return [
        'BCWI000006',
        'BCWI000007',
        'BCWI000036',
        'BCWI000037',
        'BCWI000040',
        'BCWI000041',
        'BCWI000042',
        'BCWI000043',
        'BCWI000044',
        'BCWI000045',
        'BCWI000046',
        'BCWI000047',
        'BCWI000048',
        'BCWI000049',
        'BCWI000050',
        'BCWI000051',
        'BCWI000052',
        'BCWI000053',
        'BCWI000055',
        'BCWI000056',
        'BCWI000057',
        'BCWI000058',
        'BCWI000059',
        'BCWI000060',
        'BCWI000061',
        'BCWI000062',
        'BCWI000063',
      ]
    },
  },
  watch: {
  },  
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.hea.bcs.survey.get.url
      this.evalItemListUrl = selectConfig.hea.bcs.evalItem.list.url
      // code setting
      this.$comm.getComboItems('WORK_SUIT_EVAL_ITEM_CLASS_CD').then(_result => {
        this.evalItemClasses = _result
      });
      // list setting
      this.getEvalItems();
      this.getDetail();
    },
    getDetail() {
      if (this.isOld) {    
        this.$http.url = this.$format(this.detailUrl, this.popupParam.heaBrainCardiovascularSurveyId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.$_.extend(this.survey, _result.data)
        },);
      } else {
        // nothing...
      }
    },
    getEvalItems() {
      this.$http.url = this.evalItemListUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        useFlag: 'Y'
      };
      this.$http.request((_result) => {
        this.evalItems = _result.data;

        if (!this.isOld) {
          this.$set(this.survey, 'results', this.$_.map(this.evalItems, evalItem => {
            return {
              heaBrainCardiovascularEvalResultId: '',  // 뇌심혈관계 평가결과 일련번호
              heaBrainCardiovascularSurveyId: '',  // 뇌심혈관계 일련번호
              heaBrainCardiovascularEvalItemId: evalItem.heaBrainCardiovascularEvalItemId,  // 뇌심혈관계 평가항목 일련번호
              workSuitEvalItemClassCd: evalItem.workSuitEvalItemClassCd,  // 위험요인 구분코드
              workSuitEvalItemClassName: evalItem.workSuitEvalItemClassName,  // 위험요인 구분코드
              riskFactors: evalItem.riskFactors,  // 위험요인
              riskFactorsResult: this.$_.indexOf(this.checkboxItems, evalItem.heaBrainCardiovascularEvalItemId) === -1 ? '' : 'N',  // 위험요인 평가결과(현재상태)
              riskFactorsGoalResult: '',  // 목표상태
              healthConditionCd: '',  // 건강신호등
              regUserId: this.$store.getters.user.userId,  //
              editFlag: 'C'
            }
          }))
        }
      },);
    },
    closePopup(data) {
      this.$emit('closePopup', data);  
    },
  }
};
</script>
